import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — Sayfa değiştiğinde otomatik olarak sayfa başına scroll eder.
 * React Router SPA'larında route değiştiğinde önceki scroll pozisyonu korunur;
 * bu component o davranışı düzeltir.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
